import { AUTH_BASE_URL } from "../constants/constants";
import { sendRequest } from "../utils/sendAPI";
import { getToken } from "../utils/authUtils";

// ----------------------------------------------------------------
// Get Telegram Configuration
// ----------------------------------------------------------------
export const getTeleConfig = async () => {
  try {
    const token = getToken();
    if (!token) throw new Error("Token is missing or expired");

    const response = await sendRequest({
      url: `${AUTH_BASE_URL}/authentication/telegram/config`,
      method: "GET",
      token,
    });
    return response;
  } catch (err) {
    console.error("Error get telegram bot config:", err);
    throw err;
  }
};

// ----------------------------------------------------------------
// Update Telegram Configuration
// ----------------------------------------------------------------
export const updateTeleConfig = async (body) => {
  try {
    const token = getToken();
    if (!token) throw new Error("Token is missing or expired");

    const response = await sendRequest({
      url: `${AUTH_BASE_URL}/authentication/telegram/update`,
      method: "PATCH",
      body,
      token,
    });
    return response;
  } catch (err) {
    console.error("Error updating tele bot:", err);
    throw err;
  }
};
